var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCurrency128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.672 108.723C52.7458 108.723 63.3441 98.1248 63.3441 85.0511C63.3441 71.9774 52.7458 61.379 39.672 61.379C26.5983 61.379 16 71.9774 16 85.0511C16 98.1248 26.5983 108.723 39.672 108.723Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1681 108.723C102.242 108.723 112.84 98.1248 112.84 85.0511C112.84 71.9774 102.242 61.379 89.1681 61.379C76.0944 61.379 65.4961 71.9774 65.4961 85.0511C65.4961 98.1248 76.0944 108.723 89.1681 108.723Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3449 67.8468C76.4186 67.8468 87.0169 57.2484 87.0169 44.1747C87.0169 31.101 76.4186 20.5027 63.3449 20.5027C50.2712 20.5027 39.6729 31.101 39.6729 44.1747C39.6729 57.2484 50.2712 67.8468 63.3449 67.8468Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8521 83.3567H88.3394",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8521 88.1033H88.3394",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4533 78.6322C94.0854 77.0406 92.3529 76.2449 90.2558 76.2449C87.1101 76.2449 82.4082 78.6322 82.4082 85.7322C82.4082 92.8323 86.7952 95.2195 90.2558 95.2195C92.5629 95.2195 94.2954 94.4511 95.4533 92.9142",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4585 94.035H30.2275C34.637 92.203 36.1332 89.6442 34.7161 86.3584C32.5905 81.4298 32.7539 78.0705 34.9864 76.3269C37.2188 74.5833 39.7385 74.5833 42.4225 76.6801",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2275 84.5454H42.0867",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3438 57.0858V42.0217",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3227 46.5968H70.5537",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3227 51.3354H70.5537",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7383 33.4142L63.2969 42.0222L71.9543 33.4142",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCurrency128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCurrency128.977b71a582164594aee4fb89d428a415.svg";
export { ForwardRef as ReactComponent };